import React from 'react';
import { useFormContext } from 'react-hook-form';
import DateInput from './index';

const DatePickerField = ({ name, label, placeholder, required = false }) => {
  const { setValue, watch, formState: { errors } } = useFormContext();
  const value = watch(name);

  const handleDateChange = (dateString) => {
    setValue(name, dateString, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <DateInput
      name={name}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={handleDateChange}
      error={errors[name]}
    />
  );
};

export default DatePickerField;

